import type { AssetType } from '@/types/asset';
import type { Collection } from '@/types/collection';
import type { CategoryHeader } from '@/utils/pages/api';
import { isCollection } from '../page-is-collection';
import { getCollectionBreadcrumbs } from './get-collection-breadcrumbs';
import { getMusicBreadcrumbs } from './get-music-breadcrumbs';
import { getSfxBreadcrumbs } from './get-sfx-breadcrumbs';

export const getBreadcrumbs = ({
  data,
  assetType,
}: {
  data: CategoryHeader | Collection;
  assetType: AssetType;
}) => {
  const pageIsCollection = isCollection(data);

  if (pageIsCollection) {
    if (assetType === 'music' || assetType === 'sfx') {
      return getCollectionBreadcrumbs({ collection: data, assetType });
    }
    return;
  }

  if (assetType === 'sfx') {
    return getSfxBreadcrumbs({ pageData: data });
  }

  if (assetType === 'music') {
    return getMusicBreadcrumbs({ pageData: data });
  }

  //TODO: handle other asset types in future PRs
};
